import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize'

const sanitizeSchema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames ?? []), 'u'],
}

type Props = {
  content: string
}

const MarkdownContent = ({ content }: Props) => {
  return (
    <div className="ai-markdown-content">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, [rehypeSanitize, sanitizeSchema]]}
        components={{
          pre: ({ children }) => (
            <pre style={{
              background: '#f5f5f5',
              borderRadius: 8,
              padding: 12,
              overflowX: 'auto',
              margin: '8px 0',
              fontSize: 13,
              color: '#333',
            }}>
              {children}
            </pre>
          ),
          code({ children, className }) {
            if (className) {
              return <code className={className} style={{ fontFamily: 'monospace', fontSize: 13 }}>{children}</code>
            }
            return (
              <code style={{
                background: '#f5f5f5',
                borderRadius: 4,
                padding: '1px 4px',
                fontFamily: 'monospace',
                fontSize: 13,
                color: '#333',
              }}>
                {children}
              </code>
            )
          },
          a({ children, href }) {
            return (
              <a
                href={href}
                onClick={(e) => {
                  e.preventDefault()
                  if (href) window.open(href, '_blank')
                }}
                style={{ color: '#1677ff', textDecoration: 'underline' }}
              >
                {children}
              </a>
            )
          },
          p({ children }) {
            return <p style={{ margin: '6px 0', lineHeight: 1.6 }}>{children}</p>
          },
          ul({ children }) {
            return <ul style={{ listStyle: 'disc', paddingLeft: 20, margin: '6px 0' }}>{children}</ul>
          },
          ol({ children }) {
            return <ol style={{ listStyle: 'decimal', paddingLeft: 20, margin: '6px 0' }}>{children}</ol>
          },
          li({ children }) {
            return <li style={{ lineHeight: 1.6 }}>{children}</li>
          },
          blockquote({ children }) {
            return (
              <blockquote style={{
                borderLeft: '4px solid #d9d9d9',
                paddingLeft: 12,
                margin: '8px 0',
                color: '#666',
              }}>
                {children}
              </blockquote>
            )
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}

export default MarkdownContent
